module.exports = __webpack_public_path__ + "static/media/refresh-icon.7fe58c30.svg";